// Utility for Polish typography and markup parsing for descriptions

// 1. Polish typography: non-breaking spaces for single-letter words, units, dates
export function applyPolishTypography(text) {
  if (typeof text !== 'string') return text;
  // 1. Single-letter words (conjunctions/prepositions)
  text = text.replace(/(?<=\s|^)([zaoíuwnadopzwe]) (?=\S)/gi, '$1\u00A0');
  // 2. Two-letter prepositions (na, do, od, po, za, we, ze, ku, dla, przy, pod, nad, bez, czy, jak, lub, ani, ale)
  text = text.replace(/(?<=\s|^)(na|do|od|po|za|we|ze|ku|dla|przy|pod|nad|bez|czy|jak|lub|ani|ale) (?=\S)/gi, '$1\u00A0');
  // 3. Numbers + units
  text = text.replace(/(\d+) (km|m|cm|mm|g|kg|ml|l|r\.|godz\.|min|s|st\.|zł|%)\b/gi, '$1\u00A0$2');
  // 4. Numbers + months (daty)
  text = text.replace(/(\d+) (stycznia|lutego|marca|kwietnia|maja|czerwca|lipca|sierpnia|września|października|listopada|grudnia)/gi, '$1\u00A0$2');
  return text;
}

// 2. Markup parser for [red], [b], etc.
export function parseSpecialMarkup(text) {
  if (typeof text !== 'string') return text;
  let out = text;
  // [red][b]...[/b][/red]
  out = out.replace(/\[red\]\[b\](.*?)\[\/b\]\[\/red\]/g, '<span class="extra-info-red"><strong>$1</strong></span>');
  out = out.replace(/\[blue\]\[b\](.*?)\[\/b\]\[\/blue\]/g, '<span class="extra-info-blue"><strong>$1</strong></span>');
  out = out.replace(/\[green\]\[b\](.*?)\[\/b\]\[\/green\]/g, '<span class="extra-info-green"><strong>$1</strong></span>');
  out = out.replace(/\[yellow\]\[b\](.*?)\[\/b\]\[\/yellow\]/g, '<span class="extra-info-yellow"><strong>$1</strong></span>');
  out = out.replace(/\[orange\]\[b\](.*?)\[\/b\]\[\/orange\]/g, '<span class="extra-info-orange"><strong>$1</strong></span>');
  // [b][i]...[/i][/b] and [i][b]...[/b][/i]
  out = out.replace(/\[b\]\[i\](.*?)\[\/i\]\[\/b\]/g, '<strong><em>$1</em></strong>');
  out = out.replace(/\[i\]\[b\](.*?)\[\/b\]\[\/i\]/g, '<em><strong>$1</strong></em>');
  // [i]...[/i]
  out = out.replace(/\[i\](.*?)\[\/i\]/g, '<em>$1</em>');
  // [red]...[/red] etc.
  out = out.replace(/\[red\](.*?)\[\/red\]/g, '<span class="extra-info-red">$1</span>');
  out = out.replace(/\[blue\](.*?)\[\/blue\]/g, '<span class="extra-info-blue">$1</span>');
  out = out.replace(/\[green\](.*?)\[\/green\]/g, '<span class="extra-info-green">$1</span>');
  out = out.replace(/\[yellow\](.*?)\[\/yellow\]/g, '<span class="extra-info-yellow">$1</span>');
  out = out.replace(/\[orange\](.*?)\[\/orange\]/g, '<span class="extra-info-orange">$1</span>');
  // [b]...[/b]
  out = out.replace(/\[b\](.*?)\[\/b\]/g, '<strong>$1</strong>');
  return out;
}
